module.exports = __webpack_public_path__ + "static/media/logo_moffcheck.878e29f3.png";